import { useEffect, useState } from "react";

export const useVirtualTopology = ({
  viewportRef,
  interactiveElementsArr = [],
  scale = 1,
  positionX = 0,
  positionY = 0,
  padding = { left: 0, top: 0, right: 0, bottom: 0 },
}) => {
  const [visibleElements, setVisibleElements] = useState([]);

  useEffect(() => {
    if (!viewportRef?.current || !interactiveElementsArr.length) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setVisibleElements([]);
      return;
    }

    const viewportRect = viewportRef.current.getBoundingClientRect();

    if (viewportRect.width === 0 || viewportRect.height === 0) {
      setVisibleElements(interactiveElementsArr);
      return;
    }

    const viewLeft = -positionX / scale - padding.left;
    const viewTop = -positionY / scale - padding.top;
    const viewRight =
      viewLeft + viewportRect.width / scale + padding.left + padding.right;
    const viewBottom =
      viewTop + viewportRect.height / scale + padding.top + padding.bottom;

    const elems = interactiveElementsArr.filter((el) => {
      const elLeft = el.startX;
      const elTop = el.startY;
      const elRight = elLeft + (el.width || 0);
      const elBottom = elTop + (el.height || 0);

      return (
        elRight >= viewLeft &&
        elLeft <= viewRight &&
        elBottom >= viewTop &&
        elTop <= viewBottom
      );
    });

    setVisibleElements((prev) => {
      if (
        prev.length === elems.length &&
        prev.every((el, i) => el === elems[i])
      ) {
        return prev;
      }
      return elems;
    });
  }, [
    viewportRef,
    interactiveElementsArr,
    scale,
    positionX,
    positionY,
    padding.left,
    padding.top,
    padding.right,
    padding.bottom,
  ]);

  return visibleElements;
};
